// API Reference: https://www.wix.com/corvid/reference
// “Hello, World!” Example: https://www.wix.com/corvid/hello-world

$w.onReady(function () {
	$w('#employerPhoneInput').onCustomValidation( (value, reject) => {
		phoneNumberValidator(value, reject)
	})
	$w('#employeePhoneInput').onCustomValidation( (value, reject) => {
		phoneNumberValidator(value, reject)
	})
	
	$w('#employeeId').onCustomValidation( (value, reject) => {
		if(isNaN(value)){
			reject("תעודת זהות חייבת להיות מספר")
		}

		if(value.length !== 9) {
			reject("תעודת זהות חייבת לכלול 9 ספרות")
		}
	})
});

const phoneNumberValidator = function (value, reject) {
		if(isNaN(value)){
			reject("מספר טלפון חייב להיות מספר")
		}
}

/**
 *	Adds an event handler that runs when the element is clicked.
 *	 @param {$w.MouseEvent} event
 */
export function columnStrip1_click(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
}